module.exports = __webpack_public_path__ + "media/fonts/NotoSerif-Regular-ebe1e45b05b879a9ea1f019d27a4a1a3.ttf";